module.exports = __webpack_public_path__ + "h5/img/gong.462aa0f7.jpeg";